import CryptoJS from "crypto-js";
import xpSolvService from "../service/axios/axios";

const secretKey =
  "YQ0klO4uOjYQ0klO4uOj9LaQOn2A5eGdntSkkI3I8O9LaQOnYQ0klO4uOj9LaQOn2A5eGdntSkkI3I8O2A5eGdntSkkI3I8O";
const buildNo = 2;

const isMobileDevice = () => {
  const isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

  if (isMobile) {
    console.log("This is a mobile device.");
  } else {
    console.log("This is a desktop device.");
  }
  return isMobile;
};

const createLS = (name, value) => {
  if (value && name) {
    window.localStorage.setItem(name, encryptData(value));
    if (name === "token") {
      window.localStorage.setItem("buildno", buildNo);
    }
  }
};

const getLS = (name) => {
  let results = null;

  if (
    !window.localStorage.getItem("buildno") ||
    window.localStorage.getItem("buildno") < buildNo
  ) {
    // eslint-disable-next-line no-debugger
    debugger;
    localStorage.removeItem("userInfo");
    localStorage.removeItem("token");
    localStorage.removeItem("buildno");
    window.location.href = "/login";
    return false;
  }

  if (window.localStorage.getItem(name)) {
    results = decryptData(window.localStorage.getItem(name));
  }
  if (!results) {
    window.localStorage.clear();
    window.location.href = "/login";
    return false;
  }

  return results;
};

const getUserDetails = () => {
  const userInfo = getLS("userInfo");
  if (userInfo) {
    return userInfo[0];
  }
};

const addRoleInBody = (requestBody) => {
  const userInfo = getUserDetails();
  if (requestBody && userInfo && userInfo?.idRole) {
    requestBody.idRole = userInfo?.idRole;
  }
  return requestBody;
};

const getPath = (path) => {
  const userInfo = getUserDetails();
  let newPath = `/dashboard${path}`;
  if (Number(userInfo.idRole) > 1) {
    newPath = `/institute${path}`;
  }

  return newPath;
};

const isInstitute = () => {
  const userInfo = getUserDetails();
  let institute = false;
  if (Number(userInfo.idRole) > 1) {
    institute = true
  }

  return institute;
};

const encryptData = (data) => {
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey);
  return encrypted.toString();
};

const decryptData = (encryptedData) => {
  const decrypted = CryptoJS.AES.decrypt(encryptedData, secretKey);
  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
};

const callGetAPI = (url) => Promise.resolve(xpSolvService.get(url));

const callPostAPI = (url, data) =>
  Promise.resolve(xpSolvService.post(url, data));

export default {
  isMobileDevice,
  createLS,
  getLS,
  callGetAPI,
  callPostAPI,
  getUserDetails,
  addRoleInBody,
  getPath,
  isInstitute
};
